export const RESET_PASSWORD = {
	RESET_PASSWORD_USER: 'RESET_PASSWORD_USER',
	RESET_PASSWORD_RECEIVE_RESPONSE: 'RESET_PASSWORD_RECEIVE_RESPONSE',
	RESET_PASSWORD_GET_EMAIL_BY_CODE: 'RESET_PASSWORD_GET_EMAIL_BY_CODE',
	RESET_PASSWORD_RESET_VALUES: 'RESET_PASSWORD_RESET_VALUES',
	RESET_PASSWORD_RECEIVE_RESPONSE_EMAIL_BY_CODE: 'RESET_PASSWORD_RECEIVE_RESPONSE_EMAIL_BY_CODE',
	RESET_PASSWORD_HANDLE_USER_INFO: 'RESET_PASSWORD_HANDLE_USER_INFO'
}